import { ExchangeRatesGetResponse } from "ApiClient/models";

export function convertCurrency(amount: number, fromCurrency: string, toCurrency: string, exchangeRates: ExchangeRatesGetResponse[]): number | null {
    if (fromCurrency === toCurrency) return amount;

    const exchangeRate = exchangeRates
        .filter(er => er.currencyACode === toCurrency || er.currencyBCode === toCurrency)
        .find(er => er.currencyACode === fromCurrency || er.currencyBCode === fromCurrency);

    if (!exchangeRate) return null;

    return exchangeRate.currencyACode === toCurrency ? amount / exchangeRate.multiplier : amount * exchangeRate.multiplier;
};

export function convertCurrencies(values: { currencyId: string; balance: number }[], toCurrency: string, exchangeRates: ExchangeRatesGetResponse[]): number {
    let totalValue = 0;

    for (const value of values) {
        if (value.currencyId === toCurrency) {
            totalValue += value.balance;
            continue;
        }

        totalValue += convertCurrency(value.balance, value.currencyId, toCurrency, exchangeRates) ?? 0;
    }

    return totalValue;
};